import { render } from "./PanelIndex.vue?vue&type=template&id=5024afaa&scoped=true&ts=true"
import script from "./PanelIndex.vue?vue&type=script&lang=ts"
export * from "./PanelIndex.vue?vue&type=script&lang=ts"

import "./PanelIndex.vue?vue&type=style&index=0&id=5024afaa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5024afaa"]])

export default __exports__